// extracted by mini-css-extract-plugin
export default {"stationInfo":"StationItem_stationInfo__7LtHx","dropdownSwitch":"StationItem_dropdownSwitch__pfXVS","dropdownContent":"StationItem_dropdownContent__mSSDx"};